<template>
  <div class="am_index">
    <!-- <Carousel v-model="value1" loop>
      <CarouselItem>
        <div class="demo-carousel">1</div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel">2</div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel">3</div>
      </CarouselItem>
      <CarouselItem>
        <div class="demo-carousel">4</div>
      </CarouselItem>
    </Carousel> -->
    <!-- <div class="back_div">
      <div class="back_div_left">
        <Button icon="ios-arrow-back" @click="btnHandle"></Button>
        <Dropdown @on-click="clickMenu" placement="bottom-start">
          <a href="javascript:void(0)" class="asset_info_dropdown">
            <span>{{
              isShowArchiveList ? "Archive" : "Asset Information"
            }}</span>
            <Icon type="md-menu" />
          </a>
          <DropdownMenu slot="list">
            <DropdownItem
              :selected="!isShowArchiveList"
              name="Asset Information"
              >Asset Information</DropdownItem
            >
            <DropdownItem name="BIM-AM Viewer">BIM-AM Viewer</DropdownItem>
            <DropdownItem name="Archive" :selected="isShowArchiveList"
              >Archive</DropdownItem
            >
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="back_div_right">
        <Dropdown @on-click="clickSettingMenu" placement="bottom-end">
          <Button type="text">
            <i class="mdi mdi-cog-outline"> </i>
            <span>Setting</span>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="Asset System">Asset System</DropdownItem>
            <DropdownItem name="Asset Type">Asset Type</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div> -->
    <div
      class="show_search_div"
      :class="switchSearch ? 'showSearch' : 'hideSearch'"
    >
      <div class="search_left">
        <div class="am_button_div">
          <div class="am_left">
            <Button
              type="primary"
              @click="addAsset"
              class="addAsset_btn"
              v-show="!isShowArchiveList"
              >Add Application</Button
            >

            <!-- <Dropdown @on-click="selectBatch" v-show="!isShowArchiveList">
              <Button class="addAsset_btn" type="text">Batch Operation</Button>
              <DropdownMenu slot="list">
                <DropdownItem name="add">Batch Add</DropdownItem>
                <DropdownItem name="edit">Batch modify</DropdownItem>
              </DropdownMenu>
            </Dropdown>

            <Button
              :loading="exportAssetLoading"
              type="text"
              class="exportAsset_btn"
              @click="exportAssetFun"
              >Export Asset Info</Button
            > -->
            <!-- <Drawer
              :title="deviceDetailsObj.name"
              v-model="showDeviceDrawer"
              width="500"
              :mask-closable="false"
            >
              <div slot="header">
                {{ deviceDetailsObj.name }}
                <span class="drawer_status" :class="deviceDetailsObj.status">{{
                  deviceDetailsObj.status
                }}</span>
              </div>
              <device-details
                :deviceDetailsObj="deviceDetailsObj"
              ></device-details>
            </Drawer> -->
          </div>
          <div class="am_right">
            <!-- <Tooltip content="Filter by more conditions" theme="light">
              <Button
                class="square_btn"
                :type="switchSearch ? 'primary' : 'default'"
                @click="switchSearchBtn"
              >
                <i class="mdi mdi-feature-search"></i>
              </Button>
            </Tooltip> -->
            <Select
              clearable
              filterable
              prefix="ios-folder-outline"
              style="width: 240px; margin-right: 10px"
              placeholder="Please select the app folder"
              @on-change="folderChange"
              @on-clear="folderClear"
            >
              <Option
                v-for="(item, index) in folderArr"
                :key="index"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
            <Tooltip content="Refresh" theme="light">
              <Button class="square_btn" @click="refreshAssetListFn">
                <i class="mdi mdi-refresh"></i>
              </Button>
            </Tooltip>
            <Input
              ref="inputSearchRef"
              v-model.trim="keyWords.KeyWord"
              search
              enter-button
              clearable
              placeholder="name, number"
              @on-search="searchFun"
              @on-clear="clearAssetList"
              class="input_search_clearable"
              style="width: 250px"
            />
          </div>
        </div>
        <div class="button_div" v-if="idsArr.length > 0">
          <div style="float: left; line-height: 42px; margin-left: 12px">
            {{ idsArr.length }} Selected
          </div>
          <!-- <Tooltip theme="light" max-width="500" v-show="!isShowArchiveList">
            <Button class="warn_btn" type="text" @click="changheighlight(true)"
              >Highlight</Button
            >
            <div slot="content">
              <a href="javascript:void(0)"
                >The highlighted asset will be put to the top.</a
              >
            </div>
          </Tooltip>
          <Button
            class="warn_btn"
            type="text"
            @click="changheighlight(false)"
            v-show="!isShowArchiveList"
            >Unhighlight</Button
          > -->

          <Button class="error_btn" type="text" @click="deleteSelete"
            >Delete Selected</Button
          >
          <!-- <Button class="primary_btn" type="text" @click="showArchiveModal">{{
            isShowArchiveList ? "Unarchive" : "Archive"
          }}</Button> -->
        </div>
        <!-- 删除modal -->
        <Modal :width="654" v-model="isSureDelete" title="Delete"
          ><div class="deleteModalContent">
            Are you sure to delete the APP? After this application is deleted,
            users will be unavailable. You won't be able to manage it!
            <Form
              :model="deleteModel"
              ref="deleteRef"
              :rules="ruleValidate"
              @submit.native.prevent
            >
              <FormItem
                :label="'App Name: ' + curDeleteName"
                prop="curDeleteVal"
              >
                <Input
                  v-model.trim="deleteModel.curDeleteVal"
                  clearable
                  placeholder="Please enter the app name"
                />
              </FormItem>
            </Form>
          </div>
          <div slot="footer" style="text-align: center; padding-bottom: 30px">
            <Button size="large" @click="cancelBtn" style="margin-right: 100px"
              >Cancel</Button
            >
            <Button type="error" size="large" @click="deleteSeleteFn"
              >Confirm</Button
            >
          </div>
        </Modal>
        <!-- 存档modal -->
        <Modal
          v-model="isShowArchive"
          :width="654"
          :title="isShowArchiveList ? 'Unarchive Assets' : 'Archive Assets'"
          ><div class="archiveModalContent">
            {{
              isShowArchiveList
                ? "Please confirm to unarchive this asset."
                : "Archived assets can be restored from archive list."
            }}
          </div>
          <div slot="footer" style="text-align: center; padding-bottom: 30px">
            <Button size="large" @click="cancelBtn" style="margin-right: 100px"
              >Cancel</Button
            >
            <Button type="primary" size="large" @click="ArchiveFn"
              >Confirm</Button
            >
          </div>
        </Modal>
        <!-- setting modal -->
        <SettingModal
          :showModalValue="showModalValue"
          :isShowSettingModal="isShowSettingModal"
          :systemList="systemList"
          :typeList="typeList"
          @closeModal="closeModal"
          @isAddTypeSuccess="isAddTypeSuccess"
          @isAddSystemSuccess="isAddSystemSuccess"
        ></SettingModal>
        <div class="am_table_div">
          <Card :padding="0" :shadow="false">
            <Table
              stripe
              ref="indexTable"
              :columns="indexColumns"
              :data="indexData"
              :loading="isloading"
              :row-class-name="highlightName"
              @on-selection-change="selectFn"
              @on-select-cancel="cancelFn"
              @on-select-all-cancel="cancelAllFun"
            ></Table>
          </Card>
        </div>
        <div class="paging">
          <Page
            :total="pageTotal"
            :current.sync="pageCurrent"
            show-sizer
            show-elevator
            show-total
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
      <div class="search_right">
        <Card>
          <div class="search_title">More filters</div>
          <Select
            :placeholder="locationName1"
            :disabled="searchMoreLoading"
            v-model="keyWords.locationBuildingIds"
            multiple
            class="m_p"
            v-if="showBuilding"
          >
            <Option
              v-for="(item, index) in locationBuildingArr"
              :key="index"
              :value="item.locationId"
            >
              {{ item.locationName }}
            </Option>
          </Select>
          <Select
            :placeholder="locationName2"
            :disabled="searchMoreLoading"
            v-model="keyWords.locationFloorIds"
            multiple
            class="m_p"
            v-if="showFloor"
          >
            <Option
              v-for="(item, index) in locationFloorArr"
              :key="index"
              :value="item.locationId"
            >
              {{ item.locationName }}
            </Option>
          </Select>
          <Select
            :placeholder="locationName3"
            :disabled="searchMoreLoading"
            v-model="keyWords.locationRoomIds"
            multiple
            class="m_p"
            v-if="showRoom"
          >
            <Option
              v-for="(item, index) in locationRoomArr"
              :key="index"
              :value="item.locationId"
            >
              {{ item.locationName }}
            </Option>
          </Select>
          <Divider />
          <Select
            placeholder="System"
            :disabled="searchMoreLoading"
            v-model="keyWords.SystemIds"
            multiple
          >
            <Option
              v-for="(item, index) in systemList"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </Option>
          </Select>
          <Select
            placeholder="Type"
            :disabled="searchMoreLoading"
            v-model="keyWords.TypeIds"
            multiple
            class="m_p"
          >
            <Option
              v-for="(item, index) in typeList"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </Option>
          </Select>
          <Select
            placeholder="Status"
            :disabled="searchMoreLoading"
            multiple
            v-model="keyWords.Status"
            class="m_p"
          >
            <Option value="0">Normal</Option>
            <Option value="1">Fault</Option>
            <Option value="2">Disabled</Option>
          </Select>
          <Button
            @click="searchAssetList"
            :loading="searchMoreLoading"
            type="primary"
            long
            icon="md-search"
            class="m_p"
          >
          </Button>
        </Card>
      </div>
    </div>
    <Modal
      v-model="isAddAsset"
      :title="!isEdit ? 'Add Asset' : 'Edit Asset'"
      :width="1341"
      class="asset_modal"
      @on-visible-change="isCloseAddAssetModal"
      @on-cancel="assetCancel"
    >
      <add-asset
        v-if="isAddAsset"
        :systemList="systemList"
        :typeList="typeList"
        :isAdd="isAdd"
        :isEdit="isEdit"
        :isEditAsset="isEditAsset"
        :deviceDetailsObj="deviceDetailsObj"
        @saveLoadingEmit="saveLoadingFun"
        @isAddSuccess="isAddSuccess"
      ></add-asset>
      <div slot="footer">
        <Button
          :loading="saveLoading"
          type="primary"
          size="small"
          @click="saveAssetFun"
          >{{ !isEdit ? "Add" : "Save" }}
        </Button>
      </div>
    </Modal>
    <Modal
      v-model="showBatchModal"
      :title="isAddBatch ? addBatchTitle : editBatchTitle"
      :width="batchWidth"
    >
      <div class="batchModalContent">
        <div class="batchModalContent_left">
          <template v-if="isAddBatch">
            <div class="content_div">
              1.Please export the template first. (If you already have a
              template, skip this step)
            </div>
            <Button
              class="downloadTemplateBtn"
              @click="downloadTemplateFun"
              :loading="templateLoading"
              style="margin-bottom: 10px"
            >
              <a href="javascript:void(0)">Asset Template download [.xlsx]</a>
            </Button>
            <div class="content_div">
              2. Please fill in the template according to the rules.
            </div>
            <div class="content_div">3. Upload file to add assets.</div>
          </template>
          <template v-else>
            <div class="content_div" style="font-size: 14px">
              <span
                >You can upload the exported and modified asset file (not a
                template) , If you haven't exported the file, please click</span
              ><Button
                class="downloadTemplateBtn"
                :loading="exportAssetLoading"
                @click="exportAssetFun"
              >
                <a href="javascript:void(0)"
                  >Export Asset Information [.xlsx]</a
                > </Button
              >to operate.
            </div>
          </template>
          <div class="uploadAsset">
            <UploadFile
              :actionUrl="uploadAssetUrl"
              @uploadSuccessEmit="uploadSuccessFun"
              @uploadErrorEmit="uploadErrorFun"
            ></UploadFile>
          </div>
        </div>
      </div>

      <div slot="footer">
        <Button
          type="error"
          style="float: left"
          v-if="showErrorExcel"
          @click="downloadErrorExcel"
          >Asset Info download - need to be refilled [xls, xlsx]</Button
        >
        <Button type="primary" @click="closeBatchesFun">Close</Button>
      </div>
    </Modal>
    <!-- <EchartsDiv></EchartsDiv> -->
    <Modal title="" v-model="showPopup" :width="400">
      <div style="padding-top: 16px">
        Your operation has been completed, please confirm to close the popup
      </div>
      <div slot="footer">
        <Button @click="popupOK">OK</Button>
        <Button @click="popupCancel" type="primary">Cancel</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import apiRoutes from "@/config/API_ROUTER";
import { FORMATDATE } from "@/tools/tools";
import SettingModal from "../components/SettingModal";
import AddAsset from "../components/AddAsset";
import UploadFile from "../components/UploadFile";
// import EchartsDiv from "../components/Echarts.vue";

export default {
  data() {
    return {
      deleteModel: {
        curDeleteVal: "",
      },
      ruleValidate: {
        curDeleteVal: [
          {
            required: true,
            message: "Please enter the correct app name.",
            trigger: "blur",
          },
        ],
      },
      curDeleteName: "",
      curDeleteId: "",
      value1: 1,
      locationName1: "",
      locationName2: "",
      locationName3: "",
      showPopup: false,
      pageCurrent: 1,
      showErrorExcel: false,
      uploadAssetUrl: "",
      exportAssetLoading: false,
      templateLoading: false,
      batchWidth: 660,
      indexColumns: [
        /* {
          type: "selection",
          width: 56,
          align: "center",
        }, */
        {
          title: "Icon",
          key: "imgSrc",
          // tooltip: true,
          width: 120,
          align: "center",
          render: (h, params) => {
            const img = params.row.imgSrc;
            if (img) {
              return h("img", {
                class: "app_table_img",
                attrs: {
                  src: img,
                },
              });
            }
            return h("Icon", {
              attrs: {
                type: "ios-image-outline",
                size: 30,
              },
            });
          },
        },
        {
          title: "App Name",
          key: "name",
          tooltip: true,
        },
        {
          title: "App num",
          key: "number",
        },
        {
          title: "App folder",
          key: "folderName",
          tooltip: true,
        },
        {
          title: "Type",
          key: "appTypeName",
          tooltip: true,
        },
        {
          title: "Release / Remove",
          width: 110,
          align: "center",
          render: (h, params) => {
            const e = params.row.shelfStatuses;
            return h(
              "Tag",
              {
                attrs: {
                  color: e ? "blue" : "default",
                },
              },
              e ? "Release" : "Remove"
            );
          },
        },
        {
          title: "Enable",
          key: "isEnabled",
          width: 100,
          align: "center",
          render: (h, params) => {
            const e = params.row.isEnabled;
            return h(
              "Tag",
              {
                attrs: {
                  color: e ? "blue" : "red",
                },
              },
              e ? "YES" : "NO"
            );
          },
        },
        {
          title: "Creation date",
          // key: "creationTime",
          tooltip: true,
          render: (h, params) => {
            return h("div", FORMATDATE(params.row.creationTime));
          },
        },
        {
          title: "Operation",
          align: "center",
          minWidth: 120,
          maxWidth: 150,
          render: (h, params) => {
            // let lightStatus = params.row.highlight;
            // let lightH = null;
            // if (lightStatus) {
            //   lightH = h(
            //     "DropdownItem",
            //     {
            //       props: {
            //         name: "Unhighlight",
            //       },
            //     },
            //     "Unhighlight"
            //   );
            // } else {
            //   lightH = h(
            //     "DropdownItem",
            //     {
            //       props: {
            //         name: "Highlight",
            //       },
            //     },
            //     "Highlight"
            //   );
            // }

            return h("div", [
              h("i", {
                class: "mdi mdi-eye",
                style: {
                  marginRight: "8px",
                  color: "gray",
                  "font-size": "16px",
                  cursor: "pointer",
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.deviceDrawerbtn(params);
                  },
                },
              }),

              h("i", {
                class: "mdi mdi-border-color",
                style: {
                  marginRight: "8px",
                  color: "#2db7f5",
                  "font-size": "16px",
                  cursor: "pointer",
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.showEditModal(params);
                  },
                },
              }),
              h("i", {
                class: "mdi mdi-delete",
                style: {
                  // marginRight: "15px",
                  color: "#ed4014",
                  "font-size": "16px",
                  cursor: "pointer",
                },
                on: {
                  click: (event) => {
                    event.stopPropagation();
                    this.oneDeleteSelete(params.row);
                  },
                },
              }),

              // h(
              //   "Dropdown",
              //   {
              //     attrs: {
              //       trigger: "hover",
              //       "stop-propagation": true,
              //       placement: "bottom-end",
              //     },
              //     style: {},
              //     on: {
              //       "on-click": (e) => {
              //         this.selectDropItemFn(e, params);
              //         // console.log(params);
              //       },
              //     },
              //   },
              //   [
              //     h("i", {
              //       class: "mdi mdi-dots-horizontal",
              //       style: {
              //         color: "#0976F5",
              //         "font-size": "16px",
              //         cursor: "pointer",
              //       },
              //       on: {
              //         click: (event) => {
              //           event.stopPropagation();
              //         },
              //       },
              //     }),
              //     h(
              //       "DropdownMenu",
              //       {
              //         slot: "list",
              //       },

              //       [
              //         lightH,
              //         h(
              //           "DropdownItem",
              //           {
              //             props: {
              //               name: "Archive",
              //             },
              //           },
              //           "Archive"
              //         ),
              //         h(
              //           "DropdownItem",
              //           {
              //             props: {
              //               name: "Delete",
              //             },
              //           },
              //           "Delete"
              //         ),
              //       ]
              //     ),
              //   ]
              // ),
            ]);
          },
        },
      ],
      indexData: [],
      switchSearch: false,
      systemList: [],
      typeList: [],
      searchMoreLoading: false,
      isAddAsset: false,
      showDeviceDrawer: false,
      isAdd: false,
      deviceDetailsObj: {},
      // 关键字搜索
      keyWords: {
        Folder: "",
        KeyWord: "",
        PageSize: 10,
        PageIndex: 1,
        // projectId: "",
        // Name: "",
        // SystemIds: [],
        // TypeIds: [],
        // Status: [],
        // PageSize: 10,
        // PageIndex: 1,
        // isArchive: false,
        // locationBuildingIds: [],
        // locationFloorIds: [],
        // locationRoomIds: [],
      },
      locationBuildingArr: [],
      locationFloorArr: [],
      locationRoomArr: [],
      showBuilding: false,
      showFloor: false,
      showRoom: false,
      isEdit: false,
      isEditAsset: false,
      pageTotal: 0,
      isloading: false,
      // 批量
      idsArr: [],
      // 单行
      idsArrs: [],
      isSureDelete: false,
      showBatchModal: false,
      // 区分batch的操作
      isAddBatch: false,
      // 不同操作batch时不同的样式
      addBatchTitle: "Add asset in batches",
      editBatchTitle: "Modify asset in batches",
      // 是否展示存档
      isShowArchive: false,
      isArchiveAsset: false,
      // 高亮
      ishighlightAsset: false,
      // 展示存档table
      isShowArchiveList: false,
      // setting Modal
      showModalValue: "",
      isShowSettingModal: false,
      saveLoading: false,
      folderArr: [],
      frashPage: false,
    };
  },
  methods: {
    init() {
      this.folderArr = window.defaultObj.folder;
      this.getAppFun();

      // this.keyWords.projectId =
      //   this.$route.query.projectId || "2d3919b5-98f8-4cb0-99f6-08d9dbfc1b76";

      // this.idsArr = [];
      // this.idsArrs = [];

      // this.getSystemFun();
      // this.getTypeFun();
      // this.searchAssetList();
      // this.getLocation();
    },
    folderChange(v) {
      this.keyWords.Folder = v;
      this.keyWords.PageIndex = 1;
      this.keyWords.PageSize = 10;
      this.getAppFun();
    },
    folderClear() {
      this.keyWords.Folder = "";
      this.getAppFun();
    },
    searchFun() {
      if (this.frashPage) {
        this.cancelAllFun();
        this.getAppFun();
      }
    },
    cancelAllFun() {
      this.idsArr = [];
      this.idsAll = [];
      this.keyWords.PageIndex = 1;
      this.keyWords.PageSize = 10;
    },
    getAppFun() {
      const query = {};
      Object.keys(this.keyWords).forEach((k) => {
        if (this.keyWords[k]) {
          query[k] = this.keyWords[k];
        }
      });
      const url = apiRoutes.ManageApp;
      this.$http
        .get(url, {
          params: query,
        })
        .then((res) => {
          // console.log(res);
          if (res.status === 200) {
            // this.indexData = res.data.data.list;
            const data = res.data.data.list;
            for (let i = 0; i < data.length; i += 1) {
              this.getImageFun(data[i].appAvatar, i);
            }
            this.indexData = data;
            this.pageTotal = res.data.data.total;
            this.frashPage = true;
          } else {
            this.$Notice.error({
              title: "Error",
              desc: res.data.data.message,
              duration: 20,
            });
          }
          // console.log(res);
        })
        .catch((e) => {
          // console.log(e);
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 20,
          });
        });
    },
    getImageFun(key, index) {
      window.AWS_S3_FUNCTIONS.GET_IMG_FILE(key)
        .then((res) => {
          if (res.isSuccess) {
            this.$set(this.indexData[index], "imgSrc", res.data);
          }
        })
        .catch((e) => {
          // this.$Message.error(e.err.message);
          console.log(e);
        });
    },
    saveLoadingFun(val) {
      this.saveLoading = val;
    },
    saveAssetFun() {
      this.saveLoading = true;
      if (this.isEdit) {
        this.editAssetFn();
      } else {
        this.addAssetFn();
      }
      setTimeout(() => {
        //  const del = sessionStorage.getItem("to_be_deleted_img");
        const del = this.$store.state.to_be_deleted_img;
        // console.log(del);
        if (del) {
          this.deleteFileFun(del);
        }
      }, 1500);
    },
    deleteFileFun(key) {
      window.AWS_S3_FUNCTIONS.DELETE_FILE(key)
        .then(() => {
          // console.log(res);
          //  sessionStorage.removeItem("to_be_deleted_img");
          this.$store.commit("deletetoImg");
        })
        .catch((e) => {
          this.$Message.error(e.err.message);
          // console.log(e);
        });
    },
    assetCancel() {
      setTimeout(() => {
        // console.log("zsz");
        sessionStorage.removeItem("to_be_deleted_img");
      }, 1500);
    },
    popupOK() {
      this.showPopup = false;
      this.showBatchModal = false;
    },
    popupCancel() {
      this.showPopup = false;
    },
    closeBatchesFun() {
      // this.showPopup = true;
      // return;
      if (this.showErrorExcel) {
        this.showPopup = true;
      } else {
        this.showBatchModal = false;
      }
    },
    clearAssetList() {
      /* this.keyWords = {
        Name: "",
        bimid: "",
        SystemIds: [],
        TypeIds: [],
        Status: [],
        PageSize: 10,
        PageIndex: 1,
        isArchive: false,
        locationBuildingIds: [],
        locationFloorIds: [],
        locationRoomIds: [],
      }; */
      this.keyWords.KeyWord = "";
      this.$refs.inputSearchRef.focus({
        cursor: "start",
      });
      this.getAppFun();
    },
    uploadSuccessFun() {
      this.showBatchModal = false;
      this.batchWidth = 700;
      this.searchAssetList();
    },
    uploadErrorFun() {
      // console.log(errorDetails);
      this.showErrorExcel = true;
      this.$Notice.error({
        title: "Whoops, some data errors.",
        desc: "Most of the assets were added successfully, but there are still some data errors, please export to excel to modify and re-upload.",
        duration: 25,
      });
      this.batchWidth = 1000;
      this.searchAssetList();
    },
    downloadErrorExcel() {
      const url = apiRoutes.DownloadErrorExcel;
      this.$http
        .post(
          url,
          {
            type: this.isAddBatch ? 0 : 1,
          },
          { responseType: "blob" }
        )
        .then((res) => {
          // console.log(res);
          const link = document.createElement("a");
          const b = new Blob([res.data], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          link.href = URL.createObjectURL(b);
          link.setAttribute(
            "download",
            "Asset Info download - need to be refilled.xlsx"
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(() => {
          // console.log(e);
        });
    },
    getLocation() {
      const url = apiRoutes.Location;
      this.$http.get(url).then((res) => {
        // // console.log(res);
        this.showBuilding = false;
        this.showRoom = false;
        this.showFloor = false;
        const { data } = res.data;
        if (res.data.message === "Succeed") {
          for (let i = 0; i < data.length; i += 1) {
            if (data[i].sort === 1) {
              // building
              this.locationName1 = data[i].locationLevelName;
              this.showBuilding = true;
              this.locationBuildingArr = data[i].listData;
            }
            if (data[i].sort === 2) {
              // floor
              this.locationName2 = data[i].locationLevelName;
              this.showRoom = true;
              this.locationRoomArr = data[i].listData;
            }
            if (data[i].sort === 3) {
              // room
              this.showFloor = true;
              this.locationName3 = data[i].locationLevelName;
              this.locationFloorArr = data[i].listData;
            }
          }
        }
      });
    },
    exportAssetFun() {
      const url = apiRoutes.Export;
      delete this.keyWords.PageIndex;
      delete this.keyWords.PageSize;
      // // console.log(this.keyWords);
      this.exportAssetLoading = true;
      this.$http
        .post(url, this.keyWords, { responseType: "blob" })
        .then((res) => {
          // console.log(res);
          const link = document.createElement("a");
          const b = new Blob([res.data], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          link.href = URL.createObjectURL(b);
          link.setAttribute("download", "Export Asset Info.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.exportAssetLoading = false;
        })
        .catch(() => {
          this.exportAssetLoading = false;
          // console.log(e);
        });
    },
    downloadTemplateFun() {
      const url = apiRoutes.DownloadTemplate;
      // window.open(`${url}`);
      // return;
      this.templateLoading = true;
      this.$http
        .post(url, {}, { responseType: "blob" })
        .then((res) => {
          // console.log(res);
          const link = document.createElement("a");
          const b = new Blob([res.data], { type: "application/octet-stream" });
          link.style.display = "none";
          link.href = URL.createObjectURL(b);
          link.setAttribute("download", "Asset Template download.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.templateLoading = false;
        })
        .catch(() => {
          this.templateLoading = false;
          // console.log(e);
        });
    },
    // 选择菜单
    clickMenu(name) {
      // // console.log(name);
      switch (name) {
        case "Archive":
          this.isShowArchiveList = true;
          this.refreshAssetListFn();
          break;
        case "Asset Information":
          this.isShowArchiveList = false;
          this.refreshAssetListFn();
          break;
        default:
          break;
      }
    },
    searchMore() {
      this.searchMoreLoading = true;
      setTimeout(() => {
        this.searchMoreLoading = false;
      }, 2000);
    },
    getSystemFun() {
      const url = apiRoutes.SystemAttr;
      // console.log(url);
      this.$http
        .get(url, {
          params: {
            projectId: this.keyWords.projectId,
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.message === "Succeed") {
            this.systemList = res.data.data;
          } else {
            this.systemList = [];
          }
        })
        .catch(() => {
          // console.log(e);
        });
    },
    getTypeFun() {
      const url = apiRoutes.TypeAttr;
      this.$http
        .get(url, {
          params: {
            projectId: this.keyWords.projectId,
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.message === "Succeed") {
            this.typeList = res.data.data;
          } else {
            this.typeList = [];
          }
        })
        .catch(() => {
          // console.log(e);
        });
    },
    switchSearchBtn() {
      this.switchSearch = !this.switchSearch;
      // if (this.switchSearch) {
      //   document.getElementsByClassName("show_search_div")[0].className =
      //     "show_search_div test";
      // } else {
      //   document.getElementsByClassName("show_search_div")[0].className =
      //     "show_search_div";
      // }
    },
    addAsset() {
      // this.isEdit = false;
      // this.isAddAsset = true;
      this.$router.push({
        path: "/addAsset",
        query: this.$route.query,
      });
    },
    addAssetFn() {
      this.isAdd = true;
    },
    deviceDrawerbtn(params) {
      this.$router.push({
        path: "/addAsset",
        query: Object.assign(this.$route.query, {
          appid: params.row.id,
          view: true,
        }),
      });
      // this.showDeviceDrawer = true;
    },
    searchAssetList() {
      this.isloading = true;
      this.indexData = [];
      const url = apiRoutes.AssetQuery;
      const query = {};
      // console.log(this.keyWords.Status);
      // this.keyWords.Status = this.keyWords.Status * 1;
      if (this.isShowArchiveList) {
        this.keyWords.isArchive = true;
      } else {
        this.keyWords.isArchive = false;
      }
      Object.keys(this.keyWords).forEach((key) => {
        if (this.keyWords[key]) {
          const isArr = this.keyWords[key] instanceof Array;
          if (isArr) {
            if (this.keyWords[key].length === 0) {
              // 如果是数组，并且长度为0，就跳过循环
              return;
            }
          }
          // 有内容的时候才加上
          query[key] = this.keyWords[key];
        }
      });
      // // console.log(query);
      this.$http.post(url, query).then((res) => {
        if (res.data.message === "Succeed") {
          const tempArr = res.data.data.list;
          // // console.log(tempArr);
          const arr = [];
          for (let i = 0; i < tempArr.length; i += 1) {
            arr.push(tempArr[i]);

            // arr[i]._checked = true;
          }
          Object.entries(arr).forEach(([, _v]) => {
            const v = _v;
            if (this.idsArr.includes(v.id)) {
              // eslint-disable-next-line no-underscore-dangle
              v._checked = true;
            }
          });
          this.indexData = arr;
          this.pageTotal = res.data.data.total;
          // // console.log(this.pageTotal);
          setTimeout(() => {
            // this.idsArr = [];
            this.idsArrs = [];
            this.isloading = false;
            this.pageCurrent = this.keyWords.PageIndex;
          }, 500);
        }
      });
    },
    refreshAssetListFn() {
      this.keyWords.Folder = "";
      this.keyWords.KeyWord = "";
      this.keyWords.PageIndex = 1;
      this.keyWords.PageSize = 10;
      this.idsArr = [];
      this.idsAll = [];
      this.idsArrs = [];
      this.init();
    },
    editAssetFn() {
      this.isEditAsset = !this.isEditAsset;
      this.isAdd = false;
    },
    isAddSuccess(value) {
      if (value) {
        this.isAddAsset = false;
        this.init();
      } else {
        this.isAdd = false;
      }
    },
    showEditModal(params) {
      // this.isEdit = true;
      // this.isAddAsset = true;
      // let url = apiRoutes.Asset;
      // this.$http.get(url + `/${params.row.id}`).then((res) => {
      //   // console.log(res);
      //   if (res.data.message == "Succeed") {
      //     this.deviceDetailsObj = JSON.parse(JSON.stringify(res.data.data));
      //   }
      // });
      this.$router.push({
        path: "/addAsset",
        query: {
          appid: params.row.id,
        },
      });
      // console.log(params.row);
    },
    changePage(index) {
      this.keyWords.PageIndex = index;
      this.pageCurrent = index;
      this.indexData = [];
      this.getAppFun();
    },
    changePageSize(size) {
      this.keyWords.PageSize = size;
      this.indexData = [];
      this.getAppFun();
    },
    // 高亮
    highlightName(row) {
      if (row.highlight) {
        return "highlightClass";
      }
      return "";
    },
    selectDropItemFn(name, params) {
      switch (name) {
        case "Highlight":
          this.idsArrs = [];
          this.ishighlightAsset = true;
          this.idsArrs.push(params.row.id);
          this.changheighlight(true);
          break;
        case "Unhighlight":
          this.idsArrs = [];
          this.ishighlightAsset = true;
          this.idsArrs.push(params.row.id);
          this.changheighlight(false);
          break;
        case "Archive":
          this.isShowArchive = true;
          this.idsArrs = [];
          this.idsArrs.push(params.row.id);
          this.isArchiveAsset = true;

          break;
        case "Delete":
          this.idsArrs = [];
          this.idsArrs.push(params.row.id);
          this.isDeleteId = true;
          this.isSureDelete = true;
          break;
        default:
          break;
      }
    },
    // 存档
    ArchiveFn() {
      const url = apiRoutes.Archive;
      let ids = [];
      let isArchive = false;
      if (this.isArchiveAsset) {
        ids = JSON.parse(JSON.stringify(this.idsArrs));
      } else {
        ids = JSON.parse(JSON.stringify(this.idsArr));
      }
      if (this.isShowArchiveList) {
        isArchive = false;
      } else {
        isArchive = true;
      }
      // // console.log(ids);
      const row = {
        ids,
        isArchive,
      };
      this.$http.put(url, row).then((res) => {
        if (res.data.message === "Succeed") {
          this.isShowArchive = false;
          this.init();
        }
      });
    },

    // 多选高亮
    changheighlight(status) {
      // // console.log(this.idsArr);
      const url = apiRoutes.Highlight;
      let ids = [];
      if (this.ishighlightAsset) {
        ids = JSON.parse(JSON.stringify(this.idsArrs));
      } else {
        ids = JSON.parse(JSON.stringify(this.idsArr));
      }

      const row = {
        ids,
        isHighlight: status,
      };
      this.$http.put(url, row).then((res) => {
        // console.log(res);
        if (res.data.message === "Succeed") {
          this.init();
          this.ishighlightAsset = false;
        }
      });
    },
    // 选中勾选
    selectFn(selection) {
      // // console.log(selection, "++++");
      // this.idsArr = [];
      const arr = [];
      Object.entries(selection).forEach(([, item]) => {
        arr.push(item.id);
      });

      this.idsArr = [...new Set(this.idsArr.concat(arr))];
      // // console.log(this.idsArr);
    },
    cancelFn(selection, row) {
      // console.log(selection, row);
      this.idsArr.splice(this.idsArr.indexOf(row.id), 1);
    },
    deleteSelete() {
      this.isSureDelete = true;
      this.isDeleteId = false;
    },
    oneDeleteSelete(row) {
      this.isSureDelete = true;
      this.isDeleteId = true;
      this.curDeleteId = row.id;
      this.curDeleteName = row.name;
    },
    // 批量删除
    deleteSeleteFn() {
      // console.log(",l,l,");
      this.$refs.deleteRef.validate((valid) => {
        if (valid) {
          if (this.curDeleteName === this.deleteModel.curDeleteVal) {
            const url = apiRoutes.ManageApp;
            let ids = [];
            if (this.isDeleteId) {
              ids = [this.curDeleteId];
            } else {
              ids = JSON.parse(JSON.stringify(this.idsArr));
            }
            this.$http.delete(url, { data: { ids } }).then((res) => {
              if (res.data.message === "Succeed") {
                this.isSureDelete = false;
                // this.refreshAssetListFn();
                this.getAppFun();
              }
            });
          } else {
            this.$Message.error("Please enter the correct app name.");
          }
        }
      });
    },
    cancelBtn() {
      this.isSureDelete = false;
      this.isShowArchive = false;
    },
    // 展示batch的modal
    selectBatch(name) {
      this.showErrorExcel = false;
      this.showBatchModal = false;
      // console.log(name);
      switch (name) {
        case "add":
          this.uploadAssetUrl = apiRoutes.ImportAdd;
          this.isAddBatch = true;
          this.batchWidth = 700;
          break;

        case "edit":
          this.uploadAssetUrl = apiRoutes.ImportEdit;
          this.isAddBatch = false;
          this.batchWidth = 700;
          break;
        default:
          break;
      }
      this.showBatchModal = true;
    },
    // 展示存档的modal
    showArchiveModal() {
      this.isShowArchive = true;
      this.isArchiveAsset = false;
    },
    // setting Btn
    clickSettingMenu(name) {
      this.showModalValue = name;
      this.isShowSettingModal = true;
    },
    // 监听modal
    closeModal(value) {
      if (value) {
        this.isShowSettingModal = false;
        this.showModalValue = "";
      }
    },
    // 监听addasset modal
    isCloseAddAssetModal(status) {
      if (!status) {
        this.isAdd = false;
        this.isEditAsset = false;
      }
    },
    btnHandle() {
      const data = { type: "toSaasLink", params: "toBtnHandle" };
      window.parent.postMessage(data, "*");
    },
    // 添加type
    isAddTypeSuccess() {
      // console.log(str);
      this.getTypeFun();
    },
    // 添加system
    isAddSystemSuccess() {
      this.getSystemFun();
    },
  },
  created() {
    this.init();
  },
  computed: {
    projectId() {
      return this.$route.query.projectId;
    },
  },
  watch: {
    projectId() {
      this.init();
    },
  },
  components: {
    AddAsset,

    SettingModal,
    UploadFile,
    // EchartsDiv,
  },
};
</script>
<style lang="less">
.demo-carousel {
  height: 200px;
  width: 100%;
}
.back_div {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .ivu-dropdown {
    margin-left: 16px;
  }
  .ivu-dropdown-menu {
    margin: 0 20px;
    .ivu-dropdown-item {
      border-radius: 4px;
      position: relative;
      &.ivu-dropdown-item-selected,
      &:hover {
        &::before {
          content: "";
          display: block;
          position: absolute;
          left: -20px;
          top: 4px;
          width: 4px;
          height: 24px;
          background: #0177fd;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }
  }
}
.show_search_div {
  // display: flex;
  // justify-content: space-between;
  position: relative;
  overflow-x: hidden;
  min-height: 550px;
  padding-top: 4px;
  .search_left {
    width: 100%;
  }
  .search_right {
    position: absolute;
    top: 0;
    right: -300px;
    padding-left: 16px;
    width: 294px;
    .m_p {
      margin-top: 16px;
    }
  }
}
//加入动画class
.showSearch.show_search_div {
  .search_left {
    padding-right: 300px;
    transition: padding 1s;
  }
  .search_right {
    right: 0px;
    transition: right 1s;
  }
}
//隐藏动画
.hideSearch.show_search_div {
  .search_left {
    transition: 1s;
  }
  .search_right {
    right: -300px;
    transition: right 1s;
  }
}
.am_button_div {
  display: flex;
  justify-content: space-between;
  .am_right {
    display: flex;
    // .ivu-btn {
    //   margin-right: 10px;
    // }
  }
  .am_left {
    .addAsset_btn,
    .exportAsset_btn {
      &:hover {
        background: #0976f5;
        color: #fff;
      }
    }
  }
}
.am_table_div {
  padding-top: 16px;
  border-radius: 10px;
  .ivu-card,
  .ivu-card-body,
  .ivu-table-wrapper {
    border-radius: 10px;
  }
  .ivu-table-header {
    table {
      min-height: 60px;
    }
  }
}
.asset_modal {
  .ivu-modal {
    top: 0;
  }
}
.ivu-modal-footer {
  border-top: none;
}
.paging {
  padding-top: 20px;
  padding-bottom: 150px;
  width: 100%;
  text-align: center;
}
.highlightClass {
  td:first-child {
    position: relative;
    &::before {
      content: "";
      width: 3px;
      position: absolute;
      height: 100%;
      left: 0;
      top: 0;
      background: #00a870;
    }
  }
}
.button_div {
  padding-top: 10px;
  text-align: right;
  .warn_btn {
    color: #ed7b2f;
    &:hover {
      background-color: #ed7b2f;
      color: #fff;
    }
  }
  .error_btn {
    color: #e34d59;
    &:hover {
      background-color: #e34d59;
      color: #fff;
    }
  }
  .primary_btn {
    color: #0976f5;
    &:hover {
      background-color: #0976f5;
      color: #fff;
    }
  }
}
.deleteModalContent {
  font-size: 22px;
  line-height: 32px;
  padding: 24px 60px;
  text-align: justify;
  .ivu-form {
    color: #e34d59;
    margin-top: 16px;
  }
}
.batchModalContent {
  height: 100%;
  padding: 16px 20px 0 16px;
  font-size: 16px;
  line-height: 23px;
  display: flex;
  justify-content: space-between;
  .batchModalContent_left {
    flex: 1;
    .content_div {
      margin-bottom: 10px;
    }
    .downloadTemplateBtn {
      margin: 0 10px;
      background: #f2f2f2;
      border-radius: 2px;
      width: 250px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      margin-top: 0;
      cursor: pointer;
    }
    .uploadAsset {
      cursor: pointer;
      width: 100%;
      // padding: 47px 104px 42px 104px;
      // border: 1px dashed #cfcfcf;
      border-radius: 2px;
      .uploadIcon {
        text-align: center;
        font-size: 34px;
        color: #0976f5;
      }
      .uploadContent {
        text-align: center;
      }
    }
  }
  .batchModalContent_right {
    flex: 1;
    margin-left: 20px;
  }
}
.footerBtn {
  display: flex;
  justify-content: space-around;
}
.archiveModalContent {
  font-size: 22px;
  text-align: center;
  color: #0976f5;
  padding: 40px 0;
}
.asset_info_dropdown {
  color: #2a439c;
  font-weight: bold;
  font-size: 14px;
}
.app_table_img {
  width: 48px;
  display: block;
  margin: 0 auto;
  height: 36px;
  object-fit: cover;
}
</style>
